import { environment } from "src/environments/environment";
import { errorHandler } from "src/app/util/errorHandler";
import { ActivatedRoute, Router } from "@angular/router";
import { authData } from "src/app/util/auth";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ApiService } from "src/app/http/api.service";
import { CartItemDTO, OrderDTO } from "src/app/http/api-interface";

@Component({
  selector: "app-purchase-cart",
  templateUrl: "./purchase-cart.component.html",
})
export class PurchaseCartComponent implements OnInit, OnDestroy {
  constructor(
    public apiService: ApiService,
    private httpClient: HttpClient, private router: Router, private route: ActivatedRoute) {
    }

  downloader: any = null;

  payload: any = {};
  notification = {};

  fakeLoader = false;
  showConfirmDialog = false;
  showDeleteDialog = false;
  loading = true;
  skeletonLoader = true;
  dialog = false;
  cart: OrderDTO = {};
  collectionID = "";
  confirmationText = "";
  shopItemFeeToDelete = "";
  isCart = false;

  async ngOnInit(): Promise<void> {
    
    this.route.params.subscribe((params) => {
      this.collectionID = params.collectionID ?? "";
    });

    this.isCart = !this.collectionID;

    this.cart = await this.apiService.getOrders(this.collectionID);
    this.loading = false;
    this.skeletonLoader = false;
  }
  ngOnDestroy(): void {
    this.apiService.clearNotification();
  }

  checkoutClicked() {
    this.confirmationText = "Proceed to purchase items in cart?";
    this.showConfirmDialog = true
  }

  toggleDeleteDialog(shopItemFeeID: string) {
    this.confirmationText = this.isCart ? "Are you sure you want to remove item from cart?" : "Are you sure you want to cancel item purchase?";
    this.shopItemFeeToDelete = shopItemFeeID;
    this.showDeleteDialog = true;
  }

  async checkoutCart(shouldConfirm: boolean) {
    this.showConfirmDialog = false;
    if (shouldConfirm) {
      this.loading = true;
      this.skeletonLoader = true;
      if (await this.apiService.checkoutCart()) {
        const encodedSession = encodeURIComponent(authData().Session);
        this.router.navigateByUrl(`/payments/tranzgate/${encodedSession}`);
      }
      this.cart = await this.apiService.getOrders();
      this.loading = false;
      this.skeletonLoader = false;
    }
  }

  async deleteFromCart(shouldDelete: boolean) {
    this.showDeleteDialog = false;
    if (shouldDelete) {
      this.loading = true;
      this.skeletonLoader = true;
      let cartItem: CartItemDTO = {
        ShopItemFeeID: this.shopItemFeeToDelete,
        CollectionID: this.collectionID
      };
      await this.apiService.deleteFromCart(cartItem);
      this.cart = await this.apiService.getOrders(this.collectionID);
      this.loading = false;
      this.skeletonLoader = false;
    }
  }
}
